import { User } from './../../models/user.model';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  baseUrlAdmin = environment.baseUrlAdmin;

  constructor(private http: HttpClient, private toastr: ToastrService) {}

  public create(user: any): Observable<User> {
    const service = 'administradores';
    return this.http.post<User>(this.baseUrlAdmin + service, user);
  }

  public read(): Observable<User[]> {
    const service = 'administradores';
    return this.http.get<User[]>(this.baseUrlAdmin + service);
  }

  public readById(id: string): Observable<User> {
    const service = `${'administradores'}/${id}`;
    return this.http.get<User>(this.baseUrlAdmin + service);
  }

  public delete(id: string): Observable<User> {
    const service = `${'administradores'}/${id}`;
    return this.http.delete<User>(this.baseUrlAdmin + service);
  }

  public toastSuccess(msg: string) {
    return this.toastr.success(msg);
  }

  public toastError(msg: string) {
    return this.toastr.error(msg);
  }
}
